module.exports = __webpack_public_path__ + "img/icons-sort-desc.7b603631.svg";